import Seller from "./From/Seller";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import NewDefault from "./Buttons/NewDefault";
import PoolList from "./Picking/PoolList";
import Save from "./Buttons/Save";
import Delete from "./Buttons/Delete";
import List from "./List";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import {
    CurrencyFormatter,
    ProductColumn,
    ProductName,
    productTooltip,
    UnitFormatter
} from "../../../../utils/formatters";
import TextInput from "../../../form/TextInput";
import {ifCompletedInput} from "../../../../utils/other";

const sortable = true;
const filterable = true;

let operationItemList = null;
let operationPoolItemList = null;

export default (componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons} = props;
    const Editor = props.editor || BoxEditor;
    // {...{...componentProps, props: {...componentProps.props, getProps: (name) => {return {...componentProps.props.getProps(name),fields: ["provider"]}}}}}

    const refresh = () => {
        operationItemList && operationItemList.refreshBackground();
        operationPoolItemList && operationPoolItemList.refreshBackground();
    }

    const onSourceItemUpdate = async (item, oldItem, field) => {
        const ret = await parent.onSourceItemUpdate(item, oldItem, field);
        refresh();
        return ret;
    }

    return <Fragment>
        <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
        <Editor
            theme="default"
            footer={<Fragment>
                {Array.isArray(actionButtons) ? actionButtons.map((i) => i) : actionButtons}
                <Save {...componentProps} />
                <NewDefault {...componentProps} />
                <Delete {...componentProps} />
            </Fragment>}
        >
            {
                props.values.id && <form onSubmit={props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-md-2">
                            {props.sellerType}
                        </div>
                        <div className="col-md-5">
                            <Seller {...componentProps} />
                        </div>
                        <div className="col-md-5">
                            {props.periodFilter}
                        </div>
                    </div>
                    <PoolList {...componentProps} control={{visible: false}} onSourceItemUpdate={onSourceItemUpdate} ref={(list) => operationPoolItemList = list}/>
                    <div className="form-group">
                        <label className="control-label">Tételek</label>
                        <SelectorGrid
                            ref={(list) => operationItemList = list}
                            componentConfig={props.componentConfig}
                            addButton={false}
                            onItemRemove={() => {
                                refresh();
                            }}
                            aggregations={{
                                fields: {
                                    "qty": {
                                        field: "qty", type: "SUM"
                                    },
                                    "listprice_gross_total": {
                                        field: "listprice_gross_total", type: "SUM"
                                    },
                                }
                            }}
                            name="items"
                            className="p-small-table"
                            view={props.pool.view}
                            data={props.values}
                            onItemUpdate={async (item, oldItem, field) => {
                                item.qty = item.pickedqty;
                                item.OperationItem_id = item.id;
                                item.OperationList_id = props.values[props.componentConfig.idfield];
                                return await onSourceItemUpdate(item, oldItem, field);
                            }}
                            columns={{
                                "displayname": {
                                    ...ProductColumn("component_id"),
                                    width: 8
                                },
                                "barcode": {
                                    header: 'Vonalkód',
                                    width: 2,
                                    sortable,
                                    filterable
                                },
                                "qty": {
                                    header: "Darabszám",
                                    width: 2,
                                    renderer: (value, row) => UnitFormatter(value, row.unit),
                                    sortable,
                                    filterable,
                                    className: "unit",
                                    editor:
                                        (parent) =>
                                            (props, value) =>
                                                <TextInput type="number" name="qty" label={false} value={value} focus
                                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange({...props, fieldName: "pickedqty"}, value);}}
                                                           onBlur={(e, field, value) => parent.onEditorValueChange({...props, fieldName: "pickedqty"}, value)}/>
                                },
                                "listprice": {
                                    header: 'Egységár',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    className: "currency",
                                    renderer: CurrencyFormatter
                                },
                                "listprice_gross_total": {
                                    header: 'Összesen',
                                    width: 2,
                                    sortable,
                                    filterable,
                                    className: "currency",
                                    renderer: CurrencyFormatter
                                },
                            }}
                        />
                    </div>
                </form>
            }
        </Editor>
    </Fragment>;
}